import { HiddenTextJson } from '../empracoTypes';

export default function HiddenText(contentElement: string, buttonElement: string, model: HiddenTextJson) {
  let contentDiv = document.getElementsByClassName(contentElement)[0] as HTMLDivElement;
  let link = document.getElementsByClassName(buttonElement)[0] as HTMLLinkElement;

  contentDiv.classList.add('show-less');
  contentDiv.style.maxHeight = model.height + 'px';

  link.onclick = function () {
    if (!contentDiv.classList.contains('show-less')) {
      contentDiv.classList.add('show-less');
      contentDiv.style.maxHeight = model.height + 'px';
      link.innerHTML = model.showText;
    } else {
      contentDiv.classList.remove('show-less');
      contentDiv.style.maxHeight = '2000px';
      link.innerHTML = model.hideText;
    }
  };
}